<template>
    <v-col
        :sm="12"
        :md="7"
        :lg="3"
        :xl="3">
        <div class="tes-card pa-5">
            <div class="mt-6 text-center">
                <span>
                    {{textNotification}}
                </span>
            </div>
        </div>
    </v-col>
</template>


<script>
export default {
  name: "change-tariff-notif",
  props:{
    textNotification: String,
  }
};
</script>
